export const CHART = 'chart' as const;
export const CALENDAR = 'calendar' as const;
export const CHART_MINIEVENT = 'CHART' as const;
export const CALENDAR_MINIEVENT = 'CALENDAR' as const;
export const UNKNOWN_MODE_MINIEVENT = 'UNSET_MONTH_VIEW_MODE' as const;
export const DEPARTUREDATESELECT = 'DepartureDate_Select' as const;
export const RETURNDATESELECT = 'ReturnDate_Select' as const;
export const UNKOWNDATESELECT = 'UnknownDate_Select' as const;
export const DEPART = 'Depart' as const;
export const RETURN = 'Return' as const;
export const DEPART_MINIEVENT = 'DEPART' as const;
export const RETURN_MINIEVENT = 'RETURN' as const;
export const UNKNOWN_DIRECTION_MINIEVENT = 'UNSET_DIRECTION' as const;
export const UNKNOWN = 'Unknown' as const;
export const PRICED = 'Priced' as const;
export const UNPRICED = 'Unpriced' as const;
export const UNCOLOURED = 'Uncoloured' as const;
export const TABCLICK = 'Tab-click' as const;
export const MONTHVIEW = 'month-view' as const;
export const CHECKED = 'checked' as const;
export const UNCHECKED = 'unchecked' as const;
export const MONTHNAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;
export const MONTH_PREVIOUS = 'Previous' as const;
export const MONTH_SELECT = 'Select' as const;
export const MONTH_NEXT = 'Next' as const;
export const HOTELS = 'Hotels' as const;
export const FLIGHTS = 'Flights' as const;
export const PRICE_CATEGORY_LOW = 'LOW' as const;
export const PRICE_CATEGORY_MEDIUM = 'MEDIUM' as const;
export const PRICE_CATEGORY_HIGH = 'HIGH' as const;
export const PRICE_CATEGORY_NO_PRICE = 'NO_PRICE' as const;
export const PRICE_CATEGORY_UNSET = 'UNSET_PRICE_CATEGORY' as const;
export const TRIP_TYPE_UNSET = 'UNSET_TRIP_TYPE' as const;
export const TRIP_TYPE_RETURN = 'RETURN' as const;
export const TRIP_TYPE_ONE_WAY = 'ONE_WAY' as const;
export const TRIP_TYPE_MULTI_CITY = 'MULTI_CITY' as const;
export const HOTEL_VERTICAL = 'HOTEL_VERTICAL' as const;
export const FLIGHT_VERTICAL = 'FLIGHT_VERTICAL' as const;
export const BROWSE_CITY_CITY_STAGE = 'City,City' as const;
export const BROWSE_FUNNEL_STAGE_CITY_TO_CITY = 'STAGE_CITY_TO_CITY' as const;
export const BROWSE_SERVICE_URL = 'Browse Service URL' as const;
export const BROWSE_SERVICE_NODE = 'Browse Service Node' as const;
export const EVENT_CHART_CHANGED = 'Flight Month View Chart Changed' as const;
export const EVENT_DATE_SELECTED = 'Flight Month View Date Selected' as const;
export const EVENT_HOTEL_DATE_SELECTED =
  'hotels_webE__month_view__date__selected' as const;
export const EVENT_DIRECTNESS_FILTER_CHANGED =
  'Flight Month View 1+ Stops Filter Changed' as const;
export const EVENT_ERROR_LOGGED = 'Flight Month View Error Logged' as const;
export const EVENT_MONTH_CHANGED = 'Flight Month View Month Changed' as const;
export const EVENT_SERVICE_ERROR = 'Flight Month View Service Error' as const;
export const EVENT_HOTELS_DATE_PRICES_LOADED =
  'hotels_webE__month_view__prices__loaded' as const;
export const EVENT_PAGE_LOADED = 'Flight Month View Loaded' as const;
export const EVENT_RESULTS_LOADED = 'Flight Month View Results Loaded' as const;
export const EVENT_RESULT_SELECTED =
  'Flight Month View Result Selected' as const;
export const EVENT_HOTEL_SELECTED = 'Flight Month View Hotel Selected' as const;
export const MINI_EVENT = 'miniEvent' as const;
export const ME_PROPERTY_BROWSE_FUNNEL_VERSION = 'browseFunnelVersion' as const;
export const ME_PROPERTY_BROWSE_FUNNEL_STAGE = 'browseFunnelStage' as const;
export const ME_PROPERTY_BROWSER_NAME = 'browserName' as const;
// MonthViewFlightResultsLoaded
export const ME_PROPERTY_INITIAL_LOAD = 'isInitialLoad' as const;
export const ME_PROPERTY_FIRST_VISIBLE_PRICE_DIFF_PERCENT =
  'firstVisiblePriceDiffPercent' as const;
export const ME_PROPERTY_CHEAPEST_PRICE_DIFF_PERCENT =
  'cheapestPriceDiffPercent' as const;
export const ME_PROPERTY_PROMOTED_PRICE_PROVIDER =
  'promotedPriceProvider' as const;
export const ME_PROPERTY_TRIP_TYPE = 'tripType' as const;
export const ME_PROPERTY_FULFILLED_RATIO_DEPART =
  'pricedDepartResultRatioPercent' as const;
export const ME_PROPERTY_FULFILLED_RATIO_RETURN =
  'pricedReturnResultRatioPercent' as const;
// MonthViewMonthChanged
export const ME_PROPERTY_CURRENT_MONTH = 'currentMonth' as const;
export const ME_PROPERTY_SELECTED_MONTH = 'selectedMonth' as const;
export const ME_PROPERTY_DIRECTION = 'direction' as const;
export const ME_PROPERTY_SELECTED_VIEW = 'selectedView' as const;
export const ME_PROPERTY_SELECTED_TAB = 'selectedTab' as const;
// MonthViewFlight/HotelResultSelected
export const ME_PROPERTY_SELECTED_PRICE = 'selectedPrice' as const;
export const ME_PROPERTY_BUSINESS_VERTICAL = 'vertical' as const;
export const ME_PROPERTY_ORIGIN = 'origin' as const;
export const ME_PROPERTY_DESTINATION = 'destination' as const;
export const ME_PROPERTY_OUTBOUND_DATE = 'outbound_date' as const;
export const ME_PROPERTY_INBOUND_DATE = 'inbound_date' as const;
// DateSelected
export const ME_PROPERTY_PRICE_CATEGORY = 'priceCategory' as const;
export const ME_PROPERTY_FLIGHTS_SELECTED_VIEW = 'flightsSelectedView' as const;
export const ME_PROPERTY_HOTELS_MEDIAN_PRICE = 'hotelsMedianPrice' as const;

export const MP_PROPERTY_ACTION_PAYLOAD = 'Action Payload' as const;
export const MP_PROPERTY_ACTION_TYPE = 'Action Type' as const;
export const MP_PROPERTY_CHEAPEST_PRICE_RATIO = 'Cheapest Price Ratio' as const;
export const MP_PROPERTY_CHECKED = 'Checked' as const;
export const MP_PROPERTY_DIRECTION = 'Direction' as const;
export const MP_PROPERTY_ERROR = 'Browse Funnel Error' as const;
export const MP_PROPERTY_ERROR_INFO = 'Flight Month View Error Info' as const;
export const MP_PROPERTY_ERROR_MESSAGE = 'Browse Funnel Error Message' as const;
export const MP_PROPERTY_ERROR_STAGE = 'Browse Funnel Error Stage' as const;
export const MP_PROPERTY_FIRST_VISIBLE_PRICE_RATIO =
  'First Visible Price Ratio' as const;
export const MP_PROPERTY_FUNNEL_STAGE = 'Browse Funnel Stage' as const;
export const MP_PROPERTY_INITIAL_LOAD = 'Initial Load' as const;
export const MP_PROPERTY_NO_PRICE = 'no_price' as const;
export const MP_PROPERTY_ORIGINAL_MONTH = 'Original Month' as const;
export const MP_PROPERTY_PRICE_COLOUR = 'Price Colour' as const;
export const MP_PROPERTY_PRICE_SOURCE_ID = 'Price Source Id' as const;
export const MP_PROPERTY_PROMOTED_PRICE_PROVIDER =
  'Promoted Price Provider' as const;
export const MP_PROPERTY_SEEN_COVERAGE =
  'Seen View Coverage Percentage' as const;
export const MP_PROPERTY_SEEN_DAYS = 'Seen Available Days' as const;
export const MP_PROPERTY_SELECTED_MONTH = 'Selected Month' as const;
export const MP_PROPERTY_SELECTED_PRICE = 'Selected Price' as const;
export const MP_PROPERTY_SELECTED_TAB = 'Selected Tab' as const;
export const MP_PROPERTY_SELECTED_VIEW = 'Selected View' as const;
export const MP_PROPERTY_TOTAL_COVERAGE =
  'Total View Coverage Percentage' as const;
export const MP_PROPERTY_TOTAL_DAYS = 'Total Available Days' as const;
export const MP_PROPERTY_VERSION = 'Browse Funnel Version' as const;
export const MP_PROPERTY_INDICATIVE_PRICE = 'Indicative pricing' as const;
export const MP_PROPERTY_BUCKET = 'Bucket' as const;
export const MP_PROPERTY_MEDIAN = 'Median price' as const;
export const MP_PROPERTY_CHECKIN_CHECKOUT = 'Check in/Check out' as const;
export const FLIGHTS_TAB = 'flights-tab' as const;
export const SELECTED_TAB = 'selected-tab' as const;
export const SELECTED_VIEW = 'selected-view' as const;

// Month view smart metrics
export const CTA_VERTICAL = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
} as const;

export const RECOMMENDATIONS_CARD = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  CAR: 'car',
} as const;

// Component names for logging
export const COMPONENT_CAPYBARA_RECOMMENDATIONS =
  'capybara_recommendations' as const;
